import { InfoOutlined } from "@mui/icons-material";
import { Alert, AlertColor, Stack, Typography } from "@mui/material";

export interface InlineAlertProps {
  id?: string;
  severity?: AlertColor | undefined;
  message: string;
}

/**
 * Component to display an inline alert message for the user.
 */
function InlineAlert({
  id,
  severity = "info",
  message,
}: InlineAlertProps): JSX.Element {
  return (
    <Alert
      id={id}
      severity={severity}
      icon={false}
      sx={{
        padding: "0px 16px",
      }}
    >
      <Stack direction="row" gap={1} alignItems="center" py={1}>
        <InfoOutlined sx={{ color: "info.main" }} />
        <Typography variant="body2">{message}</Typography>
      </Stack>
    </Alert>
  );
}

export default InlineAlert;
